const i18nFormatter = require('./i18nFormatter').I18nFormatter;

const NumberFormatter = {
    /**
     * Formats the specified amount for the given locale.
     * This logic was taken from https://github.homeawaycorp.com/hacommons/hacommons-i18n/blob/master/src/main/java/com/homeaway/commons/i18n/formatter/GlobalCurrencyFormatter.java#L239
     *
     * @param value the number value to format
     * @param locale the locale to determine the format of the result (defaults to 'en_US')
     * @param maximumFractionDigits the maximum number of fraction digits to keep (default to 2)
     * @param minimumFractionDigits the minimum number of fraction digits to keep (default to 0)
     * @param useGrouping whether to use separator between thousands (default to true)
     * @returns The formatted number based on the locale
     */
    formatNumber({
        value,
        locale = 'en_US',
        maximumFractionDigits = 2,
        minimumFractionDigits = 0,
        useGrouping = true
    }) {
        const options = {
            value,
            locale,
            maximumFractionDigits,
            minimumFractionDigits,
            style: 'decimal',
            useGrouping
        };
        return i18nFormatter.formatNumber(options);
    }
};

module.exports = {
    NumberFormatter
};
